/* WM collection redesign (pilot v1, 2026-10-18): sort + load more. Progressive enhancement:
   without JS, sorting falls back to the select's default and pagination links still work. */
(function () {
  var root = document.getElementById('wmc');
  if (!root) return;

  var sort = document.getElementById('wmc-sort');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      url.hash = 'wmc-results';
      window.location.href = url.toString();
    });
  }

  var btn = document.getElementById('wmc-loadmore');
  var grid = document.getElementById('wmc-grid');
  var seen = document.getElementById('wmc-seen');
  if (!btn || !grid || !window.fetch || !window.DOMParser) return;

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    var next = btn.getAttribute('href');
    if (!next || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Loading…';
    fetch(next, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#wmc-grid > .wmc-card');
        items.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
        var newSeen = doc.getElementById('wmc-seen');
        if (seen && newSeen) seen.textContent = newSeen.textContent;
        var newPager = doc.querySelector('.wmc-pager');
        var pager = root.querySelector('.wmc-pager');
        if (pager && newPager) pager.replaceWith(document.importNode(newPager, true));
        var newBtn = doc.getElementById('wmc-loadmore');
        if (newBtn) {
          btn.setAttribute('href', newBtn.getAttribute('href'));
          btn.removeAttribute('aria-busy');
          btn.textContent = 'Load more designs';
        } else {
          btn.remove();
        }
      })
      .catch(function () { window.location.href = next; });
  });
})();
